import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import LoadingSpinner from '../ui/LoadingSpinner';

type FromState = { from?: { pathname?: string } };

type PublicOnlyRouteProps = {
  children: React.ReactNode;
};

/**
 * Auth pages only: if already signed in, skip login/register and continue to the app.
 */
export const PublicOnlyRoute: React.FC<PublicOnlyRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-[#e4ebe6]"
        role="status"
        aria-live="polite"
        aria-label="Loading"
      >
        <LoadingSpinner />
      </div>
    );
  }

  if (user) {
    const from = (location.state as FromState | null)?.from?.pathname;
    const target = from && from !== '/login' && from !== '/register' ? from : '/';
    return <Navigate to={target} replace />;
  }

  return <>{children}</>;
};
